.messages {
  --viewport-padding: 1.5rem;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: var(--z-messages);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 390px;
  max-width: 100vw;
  max-height: 100vh;
  padding: var(--viewport-padding);
  margin: 0;
  overflow: auto;
  outline: none;
  list-style: none;
}

.message {
  position: relative;
  display: grid;
  grid-template-areas: "content action";
  grid-template-columns: auto max-content;
  column-gap: 1rem;
  align-items: center;
  padding: 0.75rem;
  background-color: var(--surface);
  border-radius: 6px;
  box-shadow: var(--shadow-small) rgba(0, 0, 0, 0.15);
}

.message[data-state="open"] {
  animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.message[data-state="closed"] {
  animation: hide 100ms ease-in;
}

.message[data-swipe="move"] {
  transform: translateX(var(--radix-toast-swipe-move-x));
}

.message[data-swipe="cancel"] {
  transform: translateX(0);
  transition: transform 200ms ease-out;
}

.message[data-swipe="end"] {
  animation: swipeOut 100ms ease-out;
}

.success {
  background-color: var(--message-success);
}

.danger {
  background-color: var(--message-danger);
}

.warning {
  background-color: var(--message-warning);
}

.content {
  display: flex;
  flex-direction: column;
  grid-area: content;
}

.title {
  font-size: 1rem;
  font-weight: var(--font-weight-regular);
}

.description {
  margin-top: 0.25rem;
  font-size: var(--font-size-body-2);
  line-height: var(--font-line-height);
  opacity: 0.8;
}

.action {
  grid-area: action;
  height: 25px;
  padding: 0 0.75rem;
  font-size: var(--font-size-helptext);
  line-height: var(--font-line-height);
  border: 1px solid currentColor;
  border-radius: 0.25rem;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem;
}

@keyframes hide {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes slideIn {
  from {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }

  to {
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    transform: translateX(var(--radix-toast-swipe-end-x));
  }

  to {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }
}
